
export const maskCPF = (cpf) => {
    if (!cpf) {
        return cpf
    }

    cpf = cpf.replace(/[^0-9]+/g, '')

    return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}

export const maskCNPJ = (cnpj) => {
    if (!cnpj) {
        return cnpj
    }

    cnpj = cnpj.replace(/[^0-9]+/g, '')

    return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

export function truncarString(string, x) {
	if (!string || string.length <= x) {
		return string;
	} else {
		return string.substring(0, x) + "...";
	}
}

export const maskPhoneNumber = (phoneNumber) => {
    if(!phoneNumber) return 
    
	phoneNumber = phoneNumber.replace(/\D/g, "");
	return phoneNumber.replace(/(\d{2})(\d{4,5})(\d{4})$/, "($1) $2-$3"); 
}